// extracted by mini-css-extract-plugin
module.exports = {"iconsColorToggle":"ViewEditableImage_iconsColorToggle__mlVU_"};